import { render, staticRenderFns } from "./practiceLocationForm.vue?vue&type=template&id=fa3b0db4&scoped=true&"
import script from "./practiceLocationForm.vue?vue&type=script&lang=ts&"
export * from "./practiceLocationForm.vue?vue&type=script&lang=ts&"
import style0 from "./practiceLocationForm.vue?vue&type=style&index=0&id=fa3b0db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3b0db4",
  null
  
)

export default component.exports